import { Card } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { CardTitle } from "../common";
import { FilesList } from "./FilesList";

export const AttachedFilesCard = () => {
  return (
    <Card>
      <Card.Section>
        <CardTitle>{t`Attached files`}</CardTitle>
        <FilesList />
      </Card.Section>
    </Card>
  );
};
